// extracted by mini-css-extract-plugin
export default {"root":"_1on1b","avatar":"_2m3s-"};